import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgNetworkEdit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.306 21a9.013 9.013 0 0 1-8.278-8.99C3.028 7.04 7.06 3 12.038 3c4.603 0 8.39 3.45 8.934 7.903"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.376 11.09a21 21 0 0 0-.197-2.212C14.71 5.446 13.482 3 12.04 3c-1.435 0-2.672 2.446-3.141 5.878a22 22 0 0 0-.216 3.13c0 1.107.075 2.167.216 3.142.328 2.38 1.34 4.678 2.409 5.85M3.028 12.02h8.602M14.154 20.517a.46.46 0 0 0 .505.392l1.5-.156c.35-.037.67-.214.886-.492l3.585-4.61a1.29 1.29 0 0 0-.226-1.813l-.81-.63a1.29 1.29 0 0 0-1.813.226l-3.586 4.61c-.216.278-.31.632-.259.98z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m16.631 14.979 2.787 2.166"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgNetworkEdit);
export default ForwardRef;
